import { ILane } from '@types';

// Lanes saved before `fuel_levy_id` existed only carry `fuel_levy`
export const getLaneFuelLevyId = (lane?: ILane | null): string | null => {
	return lane?.fuel_levy_id ?? lane?.fuel_levy?.id ?? null;
}
